import { connect } from 'react-redux';
import {
    clearAll,
    getCompanyStats,
    setSelectedCompanySuggestions,
    groupStatsBy,
    setFormField,
    setSelectedLeadsGraphKeys,
    setSelectedClicksGraphKeys,
    setSelectedImpressionsGraphKeys,
} from '../../reduxStore/config/companystats';
import CompanyStatsWrapper from './CompanyStatsWrapper';
import mapStatsToLineChart from '../../utils/chartAdapter/lineChartAdapter';
import { mapCompanySummaryToTable, mapProductSummaryToTable } from './companyStatisticsTableAdapter';
import { mapLeadOriginToDoughnutGraph } from '../../utils/chartAdapter/doughnutChartAdapter';

const calculateListCTR = (totalListClickCount, totalListImpressionCount) => {
    const listCtr = Math.round(
        totalListClickCount * 10000
        / totalListImpressionCount,
    ) / 100;

    return Number.isNaN(listCtr) ? '-' : `${listCtr}%`;
};

const mapStateToProps = (state, ownProps) => {
    const {
        user,
    } = state.user;

    const {
        groupBy,
        formState,
        stats,
        graphDataPointClick,
        graphDataPointImpression,
        selectedSuggestions,
        graphDataPointLead,
        graphDate,
        selectedGraphKeysLead,
        selectedGraphKeysClick,
        selectedGraphKeysImpression,
    } = state.companystats;

    const {
        companySummary,
        productSummary,
        leadOriginSummary,
        totalImpressionCount,
        totalDetailImpressionCount,
        totalListImpressionCount,
        totalClickCount,
        totalListClickCount,
        totalLeadCount,
    } = stats;

    const {
        translation,
    } = ownProps;

    const graphKeysLead = graphDataPointLead ? Object.keys(graphDataPointLead)
        .map((key, index) => (
            {
                id: index,
                text: translation.PRODUCT_KEYS[key] || key,
                isDefault: key === 'total',
            }
        ))
        : [];

    const preSelectedGraphKeysLead = selectedGraphKeysLead
        || graphKeysLead.filter(key => key.isDefault);

    const graphKeysClick = graphDataPointClick ? Object.keys(graphDataPointClick)
        .map((key, index) => (
            {
                id: index,
                text: translation.PRODUCT_KEYS[key] || key,
                isDefault: key === 'total',
            }
        ))
        : [];

    const preSelectedGraphKeysClick = selectedGraphKeysClick
        || graphKeysClick.filter(key => key.isDefault);

    const graphKeysImpression = graphDataPointImpression ? Object.keys(graphDataPointImpression)
        .map((key, index) => (
            {
                id: index,
                text: translation.PRODUCT_KEYS[key] || key,
                isDefault: key === 'total',
            }
        ))
        : [];

    const preSelectedGraphKeysImpression = selectedGraphKeysImpression
        || graphKeysImpression.filter(key => key.isDefault);

    return {
        graphData: graphDataPointClick
            && graphDate
            && graphDataPointImpression
            && graphDataPointLead
            ? {
                click: mapStatsToLineChart(
                    graphDataPointClick,
                    graphDate,
                    groupBy,
                    translation,
                ),
                impression: mapStatsToLineChart(
                    graphDataPointImpression,
                    graphDate,
                    groupBy,
                    translation,
                ),
                lead: mapStatsToLineChart(
                    graphDataPointLead,
                    graphDate,
                    groupBy,
                    translation,
                ),
            } : null,

        companyTableData: companySummary ? mapCompanySummaryToTable(
            companySummary,
            translation,
        ) : null,

        productTableData: productSummary ? mapProductSummaryToTable(
            productSummary,
            translation,
        ) : null,

        leadOriginData: leadOriginSummary ? mapLeadOriginToDoughnutGraph(
            leadOriginSummary,
            translation,
        ) : null,

        hidMap: companySummary ? companySummary.reduce((result, company) => (
            { ...result, [company.hid]: { name: company.name, city: company.city } }
        ), {}) : null,

        totalImpressionCount: totalImpressionCount ? totalImpressionCount.toLocaleString('sv-se') : null,
        totalDetailImpressionCount: totalDetailImpressionCount ? totalDetailImpressionCount.toLocaleString('sv-se') : null,
        totalListImpressionCount: totalListImpressionCount ? totalListImpressionCount.toLocaleString('sv-se') : null,
        totalClickCount: totalClickCount ? totalClickCount.toLocaleString('sv-se') : null,
        totalListClickCount: totalListClickCount ? totalListClickCount.toLocaleString('sv-se') : null,
        totalListCTR: totalListClickCount && totalListImpressionCount ? calculateListCTR(
            totalListClickCount,
            totalListImpressionCount,
        ) : null,
        totalLeadCount: totalLeadCount ? totalLeadCount.toLocaleString('sv-se') : null,

        translation,
        groupBy,
        formState,
        selectedSuggestions,
        userPreferedLanguage: state.user.preferedLanguage,
        isAnalyzeUser: user ? user.isAnalyzeUser : null,
        graphKeysLead,
        preSelectedGraphKeysLead,
        graphKeysClick,
        preSelectedGraphKeysClick,
        graphKeysImpression,
        preSelectedGraphKeysImpression,
    };
};

const mapDispatchToProps = dispatch => ({
    handleClear: () => {
        dispatch(clearAll());
    },
    handleSubmit: (formData) => {
        dispatch(getCompanyStats(formData));
    },
    handleGroupBy: (groupBy) => {
        dispatch(groupStatsBy(groupBy));
    },
    handleUpdateFormField: (field) => {
        dispatch(setFormField(field));
    },
    handleSelectCompanySuggestions: (selected) => {
        dispatch(setSelectedCompanySuggestions(selected));
    },
    handleSelectedLeadsGraphKeys: (selected) => {
        dispatch(setSelectedLeadsGraphKeys(selected));
    },
    handleSelectedClicksGraphKeys: (selected) => {
        dispatch(setSelectedClicksGraphKeys(selected));
    },
    handleSelectedImpressionsGraphKeys: (selected) => {
        dispatch(setSelectedImpressionsGraphKeys(selected));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyStatsWrapper);
